export const errorInterceptorExcludeNames = [
  'vpcnetwork', 'externalDns'
];
